import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
import ChartDownloadButton from './ChartDownloadButton';
import Model from './Model';
import { FiInfo } from 'react-icons/fi';
import { isEmpty } from 'lodash';
import BarChartBody from './BarChartBody';

function BarChartComponent({ data }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedLegend, setSelectedLegend] = useState(null);
  const [desc, setDesc] = useState('');

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleLegendSelect = legend => {
    setSelectedLegend(legend);
    setDesc(data?.info[legend] || '');
  };

  return (
    <Card className="h-100 overflow-hidden">
      <FalconCardHeader
        title={data?.label}
        titleTag="h5"
        light={true}
        desc={data?.desc}
        endEl={
          <ChartDownloadButton
            key={data?.label}
            chartData={Object.values(data.data)}
            xAxis={data.series}
            series={Object.keys(data.data)}
            filename={`${data?.label}`}
          />
          //   <ChartDownloadButton
          //   chartData={Data.data}
          //   xAxis={Data.xAxis}
          //   series={Data.Series}
          //   filename={`${Chartdata?.label}`}
          // />
        }
        infoBtn={
          !isEmpty(data?.description) && <FiInfo onClick={handleShowModal} />
        }
      />
      <Card.Body className="h-100 px-3" dir="ltr">
        <p className="units-text">{data?.unit}</p>
        <BarChartBody
          landCoverChartData={data}
          onLegendSelect={handleLegendSelect}
        />
      </Card.Body>
      <Card.Footer>
        {desc ? (
          <h5 className="infrence-info">
            {selectedLegend}: {desc}
          </h5>
        ) : (
          <></>
        )}
      </Card.Footer>
      <Model
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        description={data.description || {}}
        title={data?.label}
      />
    </Card>
  );
}

BarChartComponent.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string, // Validate label as a string
    desc: PropTypes.string, // Validate desc as a string
    unit: PropTypes.string, // Validate unit as a string
    description: PropTypes.object,
    info: PropTypes.any,
    data: PropTypes.object,
    series: PropTypes.array
  })
};

export default BarChartComponent;
